import posthog from "posthog-js"
import { posthogHost, posthogKeyNonProd, posthogKeyProd } from "../constants"

const isProduction = process.env.ENVIRONMENT === "production"

let initialized = false

export function ensurePosthogInitialized() {
  if (initialized) {
    return posthog
  }

  const apiKey = isProduction ? posthogKeyProd : posthogKeyNonProd
  if (typeof apiKey !== "string") {
    return posthog
  }

  posthog.init(apiKey, {
    api_host: posthogHost,
    disable_session_recording: false,
  })
  initialized = true

  return posthog
}

export { posthog }
